<template lang="pug">
div
  slot(:click="click")
  re-loading(v-if="isAddingToCart" loadingMessage="Your order is being processed...")
</template>

<script>
import {createNamespacedHelpers} from 'vuex'

const { mapGetters: mapCartGetters, mapActions: mapCartActions } = createNamespacedHelpers('Shop/Orders/Cart')

const ITEM_TYPE = 'buy1get1free'
const ITEM_COUNT = 2

export default {
  name: 'midwaysports-buy-1-get-1-free-button',

  data: () => ({
    isAddingToCart: false,
  }),

  computed: {
    ...mapCartGetters(['cartItems', 'cartDiscounts']),
  },

  methods: {
    ...mapCartActions(['addCartItem', 'addDiscount']),

    click() {
      if (!this.isAddingToCart) {
        this.isAddingToCart = true

        if (!this.isPromoProductAdded()) {
          const product = this.playcardProduct()
          const item = this.playcardCartItem(product)
          this.addCartItem(item)
        }

        const couponCode = this.promoCouponCode()
        if (!this.isPromoCouponAdded(couponCode)) {
          const discount = this.couponDiscount(couponCode)
          this.addDiscount(discount)
        }

        this.$router.push({ name: 'cart' })
      }
    },

    isPromoProductAdded() {
      return Object.values(this.cartItems).some(item => item.type == ITEM_TYPE)
    },

    playcardProduct() {
      const productId = window.addiesaas.midwaysports.buy1get1free.product_id
      return Object.values(window.addiesaas.products.types)
        .flat()
        .find(product => product.id == productId)
    },

    playcardCartItem(product) {
      return {
        type: ITEM_TYPE,
        total: product.price * ITEM_COUNT,
        count: ITEM_COUNT,
        payload: {
          product_id: product.id,
          count: ITEM_COUNT,
        },
        editable: false,
        attributes: {
          product: product,
        },
      }
    },

    promoCouponCode() {
      return window.addiesaas.midwaysports.buy1get1free.coupon_code
    },

    isPromoCouponAdded(code) {
      return Object.values(this.cartDiscounts)
        .some(discount => discount.payload.type == 'coupon' && discount.payload.options.code == code)
    },

    couponDiscount(code) {
      return {
        title: code,
        type: 'coupon',
        payload: {
          type: 'coupon',
          options: {
            code,
          },
        },
      }
    },
  }
}
</script>
